<template>
  <div class="min-h-screen bg-background">
    <main class="min-h-[calc(100vh-49px-24px)]">
      <slot />
    </main>
    <TabBar />
    <!-- ICP备案信息 -->
    <footer class="fixed bottom-[49px] left-0 right-0 text-center py-1 text-xs text-gray-400 bg-gray-50">
      <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" class="hover:text-gray-600 transition-colors">
        滇ICP备2025074003号
      </a>
    </footer>
  </div>
</template>

<script setup lang="ts">
</script>
